// src/pages/admin/AdminFeeSettingsPage.js
import React, { useEffect, useState, useCallback } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import { getUserFromStorage } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';
import {
  Box, Paper, Typography, TextField, Button, CircularProgress
} from '@mui/material';
import { useSnackbar } from 'notistack';
import api from '../../api/axios';
import TransactionFeeTable from '../../components/TransactionFeeTable';

const AdminFeeSettingsPage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [fee, setFee] = useState('');
  const [newFee, setNewFee] = useState('');
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();


  const fetchData = useCallback(async () => {
    try {
      const feeRes = await api.get('/settings/transaction-fee');
      setFee(feeRes.data.transaction_fee_percentage);
      setNewFee(feeRes.data.transaction_fee_percentage);

      const logsRes = await api.get('/settings/fee/logs');
      setLogs(logsRes.data);
    } catch (err) {
      enqueueSnackbar('Failed to fetch fee data', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {

    const storedUser = getUserFromStorage();
    if (storedUser?.role === 'admin') {
      setUser(storedUser);
   
    } else {
      navigate('/login'); // ✅ redirect if not admin
    }
    fetchData();
 }, [navigate,fetchData]);

 if (!user) return null;

  const handleUpdateFee = async () => {
    try {
      const parsedFee = parseFloat(newFee);
      if (isNaN(parsedFee)) {
        enqueueSnackbar('Invalid fee value', { variant: 'error' });
        return;
      }

      await api.patch('/settings/fee', { new_percentage: parsedFee });
      enqueueSnackbar('Transaction fee updated successfully', { variant: 'success' });
      fetchData(); // Refresh logs and fee
    } catch (err) {
      const message = err.response?.data?.error || 'Update failed';
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

 

  return (
    <DashboardLayout role="admin">
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
      Paramètres des frais de transaction
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : (
        <Box>
          <Typography variant="body1" sx={{ mb: 2 }}>
          Frais actuels: <strong>{fee}%</strong>
          </Typography>

          <TextField
            label="New Transaction Fee (%)"
            type="number"
            inputProps={{ step: '0.01', min: '0', max: '100' }}
            value={newFee}
            onChange={(e) => setNewFee(e.target.value)}
            sx={{ mr: 2, width: 200 }}
          />
          <Button variant="contained" onClick={handleUpdateFee}>
          MODIFIER
          </Button>

          <Box mt={4}>
            <TransactionFeeTable logs={logs} />
          </Box>
        </Box>
      )}
    </Paper>
    </DashboardLayout>
  );
};

export default AdminFeeSettingsPage;
